<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="taskType" label="任务类型" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskType==1">抖音视频</span>
                        <span v-if="scope.row.taskType==2">抖音评论</span>
                        <span v-if="scope.row.taskType==3">小红书</span>
                        <span v-if="scope.row.taskType==4">应用好评</span>
                        <span v-if="scope.row.taskType==5">快手视频</span>
                        <span v-if="scope.row.taskType==6">快手评论</span>
                    </template>
                </el-table-column>
                
                <el-table-column prop="content" label="任务内容文案" align="center" width="200"></el-table-column>
                <!-- <el-table-column prop="mediaUrl" label="素材上传" align="center" width="140">
                    <template slot-scope="scope">
                        <div v-if="scope.row.mediaUrl">
                            <div v-for="(item, index) in scope.row.mediaUrl" :key="index" style="display: inline-block; margin: 0 4px;">
                                <el-image
                                    v-if="getFileType(item) === 'image'"
                                    style="width: 50px; height: 50px;"
                                    :src="item"
                                    fit="cover" 
                                    @click="showImg(item)">
                                </el-image>
                                <div v-else-if="getFileType(item) === 'video'" 
                                    style="width: 50px; height: 50px; cursor: pointer; position: relative;"
                                    @click="showVideo(item)">
                                    <video :src="item" style="width: 100%; height: 100%; object-fit: cover;" @click.stop="showVideo(item)">
                                        <source :src="item" type="video/mp4">
                                    </video>
                                    <i class="el-icon-video-play" 
                                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 20px; color: white;">
                                    </i>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="targetUrl" label="目标链接" align="center">
                    <template slot-scope="scope">
                        <span @click="copyTargetUrl(scope.row.targetUrl)" class="cursor">{{ getHrefUrl(scope.row.targetUrl) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="reward" label="奖励金额" align="center" width="80px"></el-table-column>
                <el-table-column prop="taskStatus" label="任务状态" align="center" width="100px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskStatus==-1">审核不通过</span>
                        <span v-if="scope.row.taskStatus==0">新任务</span>
                        <span v-if="scope.row.taskStatus==1">待完成</span>
                        <span v-if="scope.row.taskStatus==2">审核中</span>
                        <span v-if="scope.row.taskStatus==3">审核完成</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="userId" label="用户id" align="center" width="80rpx"></el-table-column> -->
                <el-table-column prop="updatedAt" label="更新时间" align="center" width="160px"></el-table-column>
                <el-table-column prop="createdAt" label="创建时间" align="center" width="160px"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="120px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editTip(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        
        <!-- 新增弹窗 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="500px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        任务类型
                    </div>
                    <div class="value">
                        <el-select v-model="addFormData.taskType" placeholder="请选择" @change="addTaskTypeChange">
                            <el-option
                            v-for="item in taskTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" v-if="addFormData.taskType == 4">
                    <div class="label">
                        任务应用好评标题
                    </div>
                    <div class="value">
                        <el-input v-model="addFormData.appStoreTitle" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        任务内容文案
                    </div>
                    <div class="value">
                        <el-input v-model="addFormData.content" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <!-- 新增：抖音评论随机生成按钮 -->
                <div class="item" v-if="addFormData.taskType == 2">
                    <div class="label"></div>
                    <div class="value">
                        <el-button 
                            type="primary" 
                            size="small" 
                            icon="el-icon-refresh" 
                            @click="generateRandomCommentForAdd">
                            随机生成评论
                        </el-button>
                    </div>
                </div>

                <div class="item" v-if="addFormData.taskType != 4">
                    <div class="label">
                        素材上传
                    </div>
                    <div class="value">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="uploadImgForAdd"
                            accept="image/*,video/*">
                            <el-button size="small" type="primary">点击上传图片/视频</el-button>
                            <div slot="tip" class="el-upload__tip" style="margin-top: 5px; font-size: 12px; color: #999;">
                                支持上传图片和视频，单个文件不超过50MB
                            </div>
                        </el-upload>
                    </div>
                </div>
                
                <div class="picList">
                    <div class="pic" v-for="(item,index) in addFormData.mediaUrl" :key="index">
                        <!-- 图片预览 -->
                        <el-image
                            v-if="getFileType(item) === 'image'"
                            style="width: 100px; height: 100px"
                            :src="item"
                            :preview-src-list="[item]"
                            :fit="'cover'">
                        </el-image>
                        <!-- 视频预览 -->
                        <div v-else-if="getFileType(item) === 'video'" 
                            style="width: 100px; height: 100px; position: relative; cursor: pointer;"
                            @click="showVideo(item)">
                            <video :src="item" style="width: 100%; height: 100%; object-fit: cover;" @click.stop="showVideo(item)">
                                <source :src="item" type="video/mp4">
                            </video>
                            <i class="el-icon-video-play" 
                            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 24px; color: white; text-shadow: 0 0 5px rgba(0,0,0,0.5);">
                            </i>
                        </div>

                        <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clearAddMedia(index)">
                    </div>
                </div>

                <div class="item" v-if="addFormData.taskType==2">
                    <div class="label">
                        目标链接
                    </div>
                    <div class="value">
                        <el-input v-model="addFormData.targetUrl" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        基础奖励金额
                    </div>
                    <div class="value">
                        <el-input v-model="addFormData.reward" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="add">确认新增</el-button>
                </div>
            </div>
        </el-dialog>
        
        <!-- 编辑弹窗 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="500px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        任务类型
                    </div>
                    <div class="value">
                        <el-select v-model="editFormData.taskType" placeholder="请选择" @change="editTaskTypeChange">
                            <el-option
                            v-for="item in taskTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" v-if="editFormData.taskType == 4">
                    <div class="label">
                        任务应用好评标题
                    </div>
                    <div class="value">
                        <el-input v-model="editFormData.appStoreTitle" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        任务内容文案
                    </div>
                    <div class="value">
                        <el-input v-model="editFormData.content" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <!-- 新增：抖音评论随机生成按钮 -->
                <div class="item" v-if="editFormData.taskType == 2">
                    <div class="label"></div>
                    <div class="value">
                        <el-button 
                            type="primary" 
                            size="small" 
                            icon="el-icon-refresh" 
                            @click="generateRandomCommentForEdit">
                            随机生成评论
                        </el-button>
                    </div>
                </div>

                <div class="item" v-if="editFormData.taskType != 4">
                    <div class="label">
                        素材上传
                    </div>
                    <div class="value">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="uploadImgForEdit"
                            accept="image/*,video/*">
                            <el-button size="small" type="primary">点击上传图片/视频</el-button>
                            <div slot="tip" class="el-upload__tip" style="margin-top: 5px; font-size: 12px; color: #999;">
                                支持上传图片和视频，单个文件不超过50MB
                            </div>
                        </el-upload>
                    </div>
                </div>
                
                <div class="picList">
                    <div class="pic" v-for="(item,index) in editFormData.mediaUrl" :key="index">
                        <!-- 图片预览 -->
                        <el-image
                            v-if="getFileType(item) === 'image'"
                            style="width: 100px; height: 100px"
                            :src="item"
                            :preview-src-list="[item]"
                            :fit="'cover'">
                        </el-image>
                        <!-- 视频预览 -->
                        <div v-else-if="getFileType(item) === 'video'" 
                            style="width: 100px; height: 100px; position: relative; cursor: pointer;"
                            @click="showVideo(item)">
                            <video :src="item" style="width: 100%; height: 100%; object-fit: cover;" @click.stop="showVideo(item)">
                                <source :src="item" type="video/mp4">
                            </video>
                            <i class="el-icon-video-play" 
                            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 24px; color: white; text-shadow: 0 0 5px rgba(0,0,0,0.5);">
                            </i>
                        </div>

                        <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clearEditMedia(index)">
                    </div>
                </div>
                <div class="item" v-if="editFormData.taskType==2">
                    <div class="label">
                        目标链接
                    </div>
                    <div class="value">
                        <el-input v-model="editFormData.targetUrl" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        基础奖励金额
                    </div>
                    <div class="value">
                        <el-input v-model="editFormData.reward" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="edit">确认编辑</el-button>
                </div>
            </div>
        </el-dialog>


        <!-- 视频预览弹窗 -->
        <el-dialog 
            :visible.sync="showVideoDialog" 
            title="视频预览" 
            width="800px"
            :close-on-click-modal="false">
            <video 
                v-if="currentVideoUrl" 
                :src="currentVideoUrl" 
                controls 
                style="width: 100%; max-height: 500px;"
                autoplay>
            </video>
        </el-dialog>

    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            // 新增：抖音评论模板库
            douyinComments: [
                
            ],
            showVideoDialog: false,
            currentVideoUrl: '',
            videoExtensions: ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'webm'], // 视频格式
            imageExtensions: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'], // 图片格式

            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            tableData:[],
            conditionData:{
                // 任务类型
                taskType:null,
                // 任务状态
                taskStatus:0,
                current:1,
                size:10,
            },
            queryList:[
                {type: "select",label: "任务类型:",name: "taskType",options:[{
                    label:'抖音视频',
                    value:1,
                },{
                    label:'抖音评论',
                    value:2,
                },{
                    label:'小红书',
                    value:3,
                },{
                    label:'应用好评',
                    value:4,
                },{
                    label:'快手视频',
                    value:5,
                },{
                    label:'快手评论',
                    value:6,
                }]},
                {type: "select",label: "任务状态:",name: "taskStatus",options:[{
                    label:'审核不通过',
                    value:-1,
                },{
                    label:'新任务',
                    value:0,
                },{
                    label:'待完成',
                    value:1,
                },{
                    label:'审核中',
                    value:2,
                },{
                    label:'审核完成',
                    value:3,
                }]},
            ],
            taskTypeList:[{
                    label:'抖音视频',
                    value:1,
                },{
                    label:'抖音评论',
                    value:2,
                },{
                    label:'小红书',
                    value:3,
                },{
                    label:'应用好评',
                    value:4,
                }],
            taskStatusList:[{
                    label:'审核不通过',
                    value:-1,
                },{
                    label:'新任务',
                    value:0,
                },{
                    label:'待完成',
                    value:1,
                },{
                    label:'审核中',
                    value:2,
                },{
                    label:'审核完成',
                    value:3,
                }],
            // 新增表单数据
            addFormData:{
                taskType:'',
                appStoreTitle:'',
                content:'',
                mediaUrl:[],
                reward:null,
                taskStatus:0,
                userId:null,
                targetUrl:'',
            },
            // 编辑表单数据
            editFormData:{
                id:null,
                taskType:'',
                appStoreTitle:'',
                content:'',
                mediaUrl:[],
                reward:null,
                taskStatus:0,
                userId:null,
                targetUrl:'',
                proofImageUrl:'',
                proofLink:'',
                failureReason:'',
            },
            formList:[
                {type: "input",label: "任务类型:",name: "taskType"},
                {type: "input",label: "任务标题:",name: "title"},
                {type: "input",label: "任务描述:",name: "description"},
                {type: "input",label: "任务内容文案:",name: "content",},
                {type: "input",label: "素材上传:",name: "mediaUrl"},
                {type: "input",label: "媒体文件URL:",name: "mediaUrl"},
                {type: "input",label: "目标链接:",name: "targetUrl"},
                {type: "input",label: "基础奖励金额:",name: "reward"},
            ],
            // 提交规则
            formRules:{
               
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();
        this.loadingDouyinComments();
    },
    methods:{
        async loadingDouyinComments(){
            let res  = await api.memesList({});
            // 根据逗号分割内容，去掉换行和空格
            let contents = res.data.data.map(item => item.content.split(',').map(item => item.trim()));
            this.douyinComments = contents.flat().filter(item => item !== '');
            console.log(this.douyinComments);
        },
        copyTargetUrl(url){
            if (url) {
                window.open(this.getHrefUrl(url), '_blank');
            }
        },
        getHrefUrl(text){
            if (!text) return '';
            const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
            const urls = text.match(urlRegex);
            return urls && urls.length > 0 ? urls[0] : '';
        },
        // 新增：为新增表单随机生成评论
        generateRandomCommentForAdd() {
            const randomIndex = Math.floor(Math.random() * this.douyinComments.length);
            this.addFormData.content = this.douyinComments[randomIndex];
        },
        // 新增：为编辑表单随机生成评论
        generateRandomCommentForEdit() {
            const randomIndex = Math.floor(Math.random() * this.douyinComments.length);
            this.editFormData.content = this.douyinComments[randomIndex];
        },

        // 显示视频
        showVideo(url) {
            this.currentVideoUrl = url;
            this.showVideoDialog = true;
        },
        // 清除新增表单的媒体文件
        clearAddMedia(index){
            this.addFormData.mediaUrl.splice(index,1)
        },
        // 清除编辑表单的媒体文件
        clearEditMedia(index){
            this.editFormData.mediaUrl.splice(index,1)
        },
        // 新增表单任务类型改变
        addTaskTypeChange(type){
            if(type == 1){
                this.addFormData.reward = 5
            }else if(type == 2){
                this.addFormData.reward = 0.3
            }else if(type == 3){
                this.addFormData.reward = 4
            }else if(type == 4){
                this.addFormData.reward = 2
            }
        },
        // 编辑表单任务类型改变
        editTaskTypeChange(type){
            if(type == 1){
                this.editFormData.reward = 5
            }else if(type == 2){
                this.editFormData.reward = 0.3
            }else if(type == 3){
                this.editFormData.reward = 4
            }else if(type == 4){
                this.editFormData.reward = 2
            }
        },
        // 判断文件类型
        getFileType(url) {
            if (!url) return 'unknown';
            const extension = url.split('.').pop().toLowerCase();
            if (this.videoExtensions.includes(extension)) {
                return 'video';
            } else if (this.imageExtensions.includes(extension)) {
                return 'image';
            }
            return 'unknown';
        },
        // 新增表单上传图片
        async uploadImgForAdd(file){
            const fileType = file.file.type;
            const isImage = fileType.startsWith('image/');
            const isVideo = fileType.startsWith('video/');
            
            if (!isImage && !isVideo) {
                this.$message.error('只能上传图片或视频文件！');
                return;
            }
            
            const isLt50M = file.file.size / 1024 / 1024 < 50;
            if (!isLt50M) {
                this.$message.error('上传文件大小不能超过 50MB!');
                return;
            }
            
            let res = await api.uploadFile(file.file);
            if(!this.addFormData.mediaUrl){
                this.addFormData.mediaUrl = [];
            }
            this.addFormData.mediaUrl.push(res);
            this.$forceUpdate();
        },
        // 编辑表单上传图片
        async uploadImgForEdit(file){
            const fileType = file.file.type;
            const isImage = fileType.startsWith('image/');
            const isVideo = fileType.startsWith('video/');
            
            if (!isImage && !isVideo) {
                this.$message.error('只能上传图片或视频文件！');
                return;
            }
            
            const isLt50M = file.file.size / 1024 / 1024 < 50;
            if (!isLt50M) {
                this.$message.error('上传文件大小不能超过 50MB!');
                return;
            }
            
            let res = await api.uploadFile(file.file);
            if(!this.editFormData.mediaUrl){
                this.editFormData.mediaUrl = [];
            }
            this.editFormData.mediaUrl.push(res);
            this.$forceUpdate();
        },
        showImg(url){
            this.showBigImgList = [url];
            this.showBigImg = true;
        },
        addDialogShow(){
            // 重置新增表单数据
            this.addFormData = {
                taskType:'',
                appStoreTitle:'',
                content:'',
                mediaUrl:[],
                reward:null,
                taskStatus:0,
                userId:null,
                targetUrl:'',
            };
            this.isAddDialog = true;
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.getTaskPage({
                current:this.conditionData.current,
                size:this.conditionData.size,
                taskType:this.conditionData.taskType,
                taskStatus:this.conditionData.taskStatus,
            });
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                taskType:null,
                taskStatus:null,
                current:1,
                size:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        // 新增方法
        async add(){
            let res  = await api.saveTask(this.addFormData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.isAddDialog = false;
                this.loadingData();
            }
        },
        
        // 关闭新增和编辑的弹框
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
            }
        },
       
        editTip(item){
            // 深拷贝数据到编辑表单
            this.editFormData = JSON.parse(JSON.stringify(item));
            this.isUpdateDialog = true;
        },
        async edit(){
            let res = await api.updateTask(this.editFormData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },

        deleteTip(item){
            this.$confirm('将删除此任务?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async del(item){
            let res = await api.deleteTask(item.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                display: flex;
                width: 400px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            margin:0 10px;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: -10px;
                    right: -10px;
                    width: 22px;
                    height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            justify-content: center;
            .el-button{
                margin-right: 10px;
            }
        }
    }
    .cursor{
        cursor: pointer;
    }
</style>
